export default __webpack_public_path__ + "media/images/react_icons/googlemaps-0120f55afba23d90b397aa4af0dfc5a8.svg";